import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { usePutPayoutDestination } from 'legacy/events/hooks';
import { showModal } from '../../../../../legacy/actions/modalActions';
import {
  EventPayoutDestination,
  PayoutBank as PayoutBankDto
} from 'legacy/events/types';

import DestinationForm from './components/DestinationForm';
import SelectedDestination from './components/SelectedDestination';
import retrieveDefaultCurrentSelection from './helpers/retrieveDefaultCurrentSelection';
import getBankByStripeId from './helpers/getBankByStripeId';

type Props = {
  banks: {
    hostBanks: PayoutBankDto[];
    associationsBanks: PayoutBankDto[];
  };
  eventId: string;
  disabled: boolean;
  payoutDestination?: EventPayoutDestination;
};

const PayoutDestination: React.FC<Props> = ({
  banks,
  eventId,
  disabled,
  payoutDestination
}) => {
  const putPayoutDestination = usePutPayoutDestination();
  const dispatch = useDispatch();
  const [showForm, setShowForm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentSelection, setCurrentSelection] = useState(
    retrieveDefaultCurrentSelection(payoutDestination, banks, eventId)
  );

  const toggleShowForm = () => {
    setShowForm((prevState) => !prevState);
  };

  const onSubmit = ({ bank }) => {
    setIsLoading(true);
    setShowForm(false);

    const selectedBank = getBankByStripeId(banks, bank);

    putPayoutDestination.mutate(
      { eventId, bankId: selectedBank?.id || null },
      {
        onSuccess: () => {
          setCurrentSelection(selectedBank || null);
          setIsLoading(false);
        },
        onError: (error) => {
          dispatch(
            showModal('ALERT', {
              message: error?.message
            })
          );
          setIsLoading(false);
        }
      }
    );
  };

  if (disabled || (!disabled && !showForm)) {
    return (
      <SelectedDestination
        destination={currentSelection}
        disabled={disabled}
        isLoading={isLoading}
        onShowForm={toggleShowForm}
      />
    );
  }

  return (
    <DestinationForm
      banks={banks}
      isLoading={isLoading}
      currentSelection={currentSelection}
      onSubmit={onSubmit}
      onCancel={toggleShowForm}
    />
  );
};

export default PayoutDestination;
